import { createContext } from "react";

export interface Config {
  AUTH_CLIENT_ID: string;
  AUTH_AUTHORITY: string;
  AUTH_AUTHORITY_KNOWNS?: string;
  AUTH_SCOPE: string;
  API_URL: string;
  DESIGNER_ORIGIN?: string;
  GOOGLE_MAPS_API_KEY?: string;
  EMBED_MANIFEST?: unknown;
  EMBED_PERFORMANCE?: (phase: string) => void;
  EMBED_FETCH?: (url: RequestInfo, init?: RequestInit) => Promise<Response>;
  EMBED_STYLE_ROOT?: HTMLElement;
  EMBED_INSTANCE_ID?: string;
}

const ConfigContext = createContext<Config>(null as any);

export default ConfigContext;
